import { CTAW_TYPE, NUDGES_TYPE } from "@modules/nudges/types";
import {
    array,
    literal,
    nullable,
    number,
    object,
    optional,
    string,
    union,
} from "superstruct";

export const NudgesSchema = object({
    nudge: object({
        id: string(),
        createdAt: string(),
        pages: array(string()),
        payload: nullable(
            object({
                points: optional(number()),
                code: optional(string()),
                discountId: optional(number()),
                title: optional(string()),
                type: optional(string()),
                value: optional(number()),
                valueType: optional(string()),
                giftCardId: optional(number()),
            })
        ),
        type: union([
            literal(NUDGES_TYPE.JoinRewardProgramTemplate),
            literal(NUDGES_TYPE.PointsSpendingTemplate),
            literal(NUDGES_TYPE.RewardAvailableTemplate),
        ]),
        shopId: number(),
        recipient: object({
            customerId: optional(number()),
            sessionToken: optional(string()),
            type: string(),
        }),
    }),
    template: object({
        type: union([
            literal(NUDGES_TYPE.JoinRewardProgramTemplate),
            literal(NUDGES_TYPE.PointsSpendingTemplate),
            literal(NUDGES_TYPE.RewardAvailableTemplate),
        ]),
        title: string(),
        locale: string(),
        icon: string(),
        description: string(),
        ctaw: object({
            type: union([
                literal(CTAW_TYPE.BUTTON_APPLY_DISCOUNT),
                literal(CTAW_TYPE.BUTTON_LINK),
                literal(CTAW_TYPE.LOGIN_OR_SIGN_UP),
                literal(CTAW_TYPE.BUTTON_REDEEM_REWARD),
            ]),
            text: optional(string()),
            link: optional(string()),
            loginLink: optional(string()),
            loginText: optional(string()),
            signUpText: optional(string()),
            signUpLink: optional(string()),
        }),
    }),
});
